import { Container } from "@material-ui/core";
import React from "react";
import FoodProcessorClub from "../Club/FoodProcessorClub";
import DeviceMakerServices from "./DeviceMakerServices";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";

export default function DeviceMakerClub() {
  const userTypes = ["AssetDeveloper"];

  return (
    <>
      <UpdatesBanner bannerTitle="Device Makers" className="device-maker-bg" />
      <DeviceMakerServices />

      <Container className="subSectionWrapper">
        <div className=" pb-0">
          <h2 className="container-title mb-md-5 text-center">
            Agri-Solution Providers
          </h2>
          <FoodProcessorClub
            type={userTypes}
            userTypeRole="
            SystemIntegrator"
            explore="true"
          />
        </div>
      </Container>
    </>
  );
}
